<div class="flex flex-row flex-wrap gap-0 h-min">
  @for (payer of payers; track payer) {
    <div class="p-[5px]">
      <ag-grid-angular
        [id]="payer"
        [gridId]="payer"
        class="ag-theme-balham ag-theme-dx-event-summary-report w-[710px]"
        domLayout="autoHeight"
        [context]="gridContext"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [loadingOverlayComponent]="loadingOverlayComponent"
        [excelStyles]="excelStyles"
      [suppressContextMenu]="true"></ag-grid-angular>
    </div>
  }
</div>
